const cm_cd_api_mapping = {
    cm: ["Admin/ReassignSites", "Publish/UpdateStatus", "account/Save"]
};
export default cm_cd_api_mapping;
